export function indexToLetter(index) {
  if (index < 0) return ''
  const digit2 = Math.floor(index / 26)
  const digit1 = index % 26
  return [
    digit2 > 0 ? String.fromCharCode(digit2 + 64) : '',
    String.fromCharCode(digit1 + 65)
  ].join('')
}
